export default __webpack_public_path__ + "static/media/pm-img.a934165f.jpg";